import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';

import NamedLink from '../NamedLink/NamedLink';

import css from './BackToDashboard.module.css';

/**
 * Near-top link back to Dashboard from Inbox, profile, payouts, and similar hub pages.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className]
 * @param {string} [props.rootClassName]
 * @returns {JSX.Element}
 */
const BackToDashboard = props => {
  const { className, rootClassName } = props;
  return (
    <NamedLink
      className={classNames(rootClassName || css.root, className)}
      name="DashboardPage"
      data-testid="back-to-dashboard"
    >
      <span className={css.chevron} aria-hidden="true">
        ‹
      </span>
      <FormattedMessage id="BackToDashboard.label" />
    </NamedLink>
  );
};

export default BackToDashboard;
